import { controls, currencyToNumber, grouped } from "../../controls";

const rpsl17 = {
  label: "Priority Sector Loan To Weaker SLBC",
  starting: true,
  url: "rpsl17",
  pageLabel: "Priority Sector Loan To Weaker SLBC",
  pageType: "history",
  // filteraction: true,
  filter: [


    ...controls.displayText({ tab: "filter", label: "Reporting Season", star: true }),
    ...controls.autoComplete({ tab: "filter", name: "manual_report_master_code", width: "col-sm-2", controlType: "ManualReportMaster" }),
    ...controls.displayText({ tab: "filter", label: "" }),

  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Priority Sector Loan To Weaker SLBC",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait"
    },
    textReportProps: {
      'slbc': {
        filename: `Priority Sector Loan To Weaker.txt`,
        format: {},
        separator: "|"
      },
    },
    displayColumns: [
      {
        Header: "State Code",
        accessor: "slbc_state_no",

      },

      {
        Header: "District Code",
        accessor: "slbc_district_no",

      },
      {
        Header: "Block Code",
        accessor: "slbc_block_code",
      },

      {
        Header: "Small & Marginal Farmers A/c",
        accessor: "small_marginal_farmers_ac",

      },
      {
        Header: "Small & Marginal Farmers Amount",
        accessor: "small_marginal_farmers_amt",
        type: "currency"
      },
      {
        Header: "Scheduled Castes A/c",
        accessor: "scheduled_castes_ac",

      },
      {
        Header: "Scheduled Castes Amount",
        accessor: "scheduled_castes_amt",
        type: "currency"
      },
      {
        Header: "Scheduled Tribes A/c",
        accessor: "scheduled_tribes_ac",

      },
      {
        Header: "Scheduled Tribes Amount",
        accessor: "scheduled_tribes_amt",
        type: "currency"
      },
      {
        Header: "Beneficiaries of DRI Scheme A/c",
        accessor: "beneficiaries_of_dri_scheme_ac",

      },
      {
        Header: "Beneficiaries of DRI Scheme Amount",
        accessor: "beneficiaries_of_dri_scheme_amt",
        type: "currency"
      },

      {
        Header: "SHG A/C",
        accessor: "shg_ac",

      },
      {
        Header: "SHG Amount",
        accessor: "shg_amt",
        type: "currency"
      },
      {
        Header: "Individual Woen Beneficiaries up to 1 lakh A/c",
        accessor: "individual_women_beneficiaries_ac",

      },
      {
        Header: "Individual Woen Beneficiaries up to 1 lakh Amount",
        accessor: "individual_women_beneficiaries_amt",
        type: "currency"
      },
      {
        Header: "Minority Communities as may be notified by GOI from time to time A/c",
        accessor: "minority_communities_ac",

      },
      {
        Header: "Minority Communities as may be notified by GOI from time to time Amount",
        accessor: "minority_communities_amt",
        type: "currency"
      },
      {
        Header: "Overdrafts upto 5000/- under PMJDY A/Cs, Provided the borrower's household annual incoe does not exceed 100,000/- for rural areas and 160,000/- for non rural areas A/c",
        accessor: "overdrafts_ac",

      },
      {
        Header: "Overdrafts upto 5000/- under PMJDY A/Cs, Provided the borrower's household annual incoe does not exceed 100,000/- for rural areas and 160,000/- for non rural areas Amount",
        accessor: "overdrafts_amt",
        type: "currency"
      },
      {
        Header: "Other Loans to weaker section A/c",
        accessor: "other_loans_ac",

      },
      {
        Header: "Other Loans to weaker section Amount",
        accessor: "other_loans_amt",
        type: "currency"
      },
    ]
  }
};

export default rpsl17;